/*@ngInject*/
const ConfiguredFileUtil = function (coreMediator) {

    this.getConfiguredFileLinkURL = function (configuredFileId, configuredFileName) {
        configuredFileName = _.replace(configuredFileName, /[#/@'"]/gi, '');
        return coreMediator.getSingleUseToken().then((token) => {
            const encodedConfiguredFileName = configuredFileName ? encodeURIComponent(configuredFileName) : null;
            const configuredFileNamePath = encodedConfiguredFileName ? '/' + encodedConfiguredFileName : '';
            const configuredFileNameParameter = encodedConfiguredFileName ? ' filename="' + encodedConfiguredFileName + '"' : '';
            const t = encodeURIComponent(token);

            return `/configuredFiles${configuredFileNamePath}?id=${configuredFileId}&t=${t}&contentDisposition=inline;${configuredFileNameParameter}`;
        });
    };
};

angular.module('umCore')
    .service('configuredFileUtil', ConfiguredFileUtil);
